import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'gar-ui-callback-page',
  template: `
    <div style="min-height:450px; text-align: center; margin-top: 100px;">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </div>
  `,
  styles: []
})
export class CallbackComponent implements OnInit {

  constructor(
    public router: Router,
    private authSvc: AuthService
  ) { }

  ngOnInit() {
     this.authSvc.handleAuthentication();
    this.router.navigate(['']);
  }

}
